import { OnDestroy } from "@angular/core";
import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild,
    ViewContainerRef,
} from "@angular/core";
import * as _ from "lodash";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";

@Component({
    selector: "grid-header",
    templateUrl: "./grid-header.component.html",
    standalone: false
})
export class _GridHeaderComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBusService: EventBusService,
        private viewContainerRef: ViewContainerRef
    ) {}
    @ViewChild("headerTemplate", { static: true })
    headerTemplate;
    IsSelectAllSelected: any = false;

    sub = new SubSink();
    query: any = {};
    buAccess: any;
    departments: any;

    hasTalentDepartment = false;
    hasFinanceDepartment = false;
    hasPayrollDepartment = false;

    dept_Operation = "SUBMITTER";
    dept_Talent = "APPROVER";
    dept_Finance = "FINANCE";
    dept_Payroll = "PAYROLL";

    getUiDeptSettings() {
        return {
            isOperationDeptExpanded: false,
            hasOperationAccess: false,
            isTalentDeptExpanded: false,
            hasApproverAccess: false,
            isFinanceDeptExpanded: false,
            hasFinanceAccess: false,
            isPayrollDeptExpanded: false,
            hasPayrollAccess: false,
        };
    }
    uiDeptSettings: any = this.getUiDeptSettings();

    toggleUiDeptVisibility(deptVariable, value?) {
        this.uiDeptSettings[deptVariable] = value
            ? value
            : !this.uiDeptSettings[deptVariable];
    }

    emitLatestUiSettings() {
        this._eventBusService.emit(
            new EmitEvent(
                "toggleUiDeptVisibility",
                "uiDeptVisibilityChanged",
                this.uiDeptSettings
            )
        );
    }

    getBUAccessKeyList(departments) {
        const deptKeysWithAccess = [];
        if (!_.isEmpty(departments)) {
            let currentSeqNo = 0;
            departments = _.orderBy(departments, ["displaySequence"], ["asc"]);
            //var currentSeqNo = _.find(departments, { "id": BuAccess.departmentId }).displaySequence;
            _.forEach(departments, (dept) => {
                if (dept.department.id === this.buAccess.departmentId) {
                    currentSeqNo = dept.displaySequence;
                }
            });
            _.forEach(departments, (dept) => {
                if (dept.displaySequence <= currentSeqNo) {
                    deptKeysWithAccess.push(dept.department.externalKey);
                }
            });
        }
        return deptKeysWithAccess;
    }

    initUiDeptSections(deptKeysWithAccess) {
        let currentUserDeptKey = null;
        _.forEach(this.departments, (dept) => {
            if (dept.department.id === this.buAccess.departmentId) {
                currentUserDeptKey = dept.department.externalKey;
            }
        });
        //link the allowed event handlers
        _.forEach(deptKeysWithAccess, (deptKey) => {
            switch (deptKey) {
                case this.dept_Operation:
                    //TODO: do this in UI
                    if (deptKey === currentUserDeptKey) {
                        this.toggleUiDeptVisibility("isOperationDeptExpanded");
                        this.uiDeptSettings.hasOperationAccess = true;
                    }
                    break;
                case this.dept_Talent:
                    if (deptKey === currentUserDeptKey) {
                        this.toggleUiDeptVisibility("isOperationDeptExpanded");
                        this.toggleUiDeptVisibility("isTalentDeptExpanded");
                        this.uiDeptSettings.hasOperationAccess = true;
                        this.uiDeptSettings.hasApproverAccess = true;
                    }
                    break;
                case this.dept_Finance:
                    if (deptKey === currentUserDeptKey) {
                        this.toggleUiDeptVisibility("isOperationDeptExpanded");
                        this.toggleUiDeptVisibility("isTalentDeptExpanded");
                        this.toggleUiDeptVisibility("isFinanceDeptExpanded");
                        this.uiDeptSettings.hasOperationAccess = true;
                        this.uiDeptSettings.hasApproverAccess = true;
                        this.uiDeptSettings.hasFinanceAccess = true;
                    }
                    break;
                case this.dept_Payroll:
                    if (deptKey === currentUserDeptKey) {
                        this.toggleUiDeptVisibility("isPayrollDeptExpanded");
                        this.uiDeptSettings.hasOperationAccess = true;
                        this.uiDeptSettings.hasApproverAccess = true;
                        this.uiDeptSettings.hasFinanceAccess = true;
                        this.uiDeptSettings.hasPayrollAccess = true;
                    }
                    break;
            }
        });
    }

    manipulateDeptAccess() {
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "APPROVER") {
                this.hasTalentDepartment = true;
            }
        });
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "FINANCE") {
                this.hasFinanceDepartment = true;
            }
        });
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "PAYROLL") {
                this.hasPayrollDepartment = true;
            }
        });
    }

    changeDeptVisibilityByDept(dept, value) {
        switch (dept) {
            case this.dept_Operation:
                this.toggleUiDeptVisibility("isOperationDeptExpanded", value);
                break;
            case this.dept_Talent:
                this.toggleUiDeptVisibility("isTalentDeptExpanded", value);
                break;
            case this.dept_Finance:
                this.toggleUiDeptVisibility("isFinanceDeptExpanded", value);
                break;
            case this.dept_Payroll:
                this.toggleUiDeptVisibility("isPayrollDeptExpanded", value);
                break;
        }
    }

    expandDeptColumns(deptName) {
        this.changeDeptVisibilityByDept(deptName, true);
        this.emitLatestUiSettings();
    }

    collapseDeptColumns(deptName) {
        this.changeDeptVisibilityByDept(deptName, false);
        this.emitLatestUiSettings();
    }

    onSelectAllRecordsChange() {
        this.IsSelectAllSelected = !this.IsSelectAllSelected;
        this._eventBusService.emit(
            new EmitEvent(
                "grid:header",
                "onSelectAllRecordsChange",
                this.IsSelectAllSelected
            )
        );
    }

    onSortByColumn(dataField) {
        this._eventBusService.emit(
            new EmitEvent(
                "grid:header:onSortByColumn",
                "onSortByColumn",
                dataField
            )
        );
    }

    setSortByCol(column) {
        this.query.sortByColumn = column;
    }

    setReverseSort(sortOrder) {
        this.query.reverseSort = sortOrder;
    }

    subscribeEventHandlers() {
        this.sub.sink = this._eventBusService.on(
            "collapseDeptColumns",
            (deptName) => this.collapseDeptColumns(deptName)
        );

        this.sub.sink = this._eventBusService.on(
            "onAllRecordsSelected",
            (IsSelectAllSelected) =>
                (this.IsSelectAllSelected = IsSelectAllSelected)
        );
        this.sub.sink = this._eventBusService.on(
            "receiveBroadcastedMasterData",
            (data) => {
                this.buAccess = data.buAccess;
                this.departments = data.departments;
                this.manipulateDeptAccess();
                const deptKeysWithAccess = this.getBUAccessKeyList(
                    this.departments
                );
                this.initUiDeptSections(deptKeysWithAccess);
                setTimeout(() => this.emitLatestUiSettings(), 100);
            }
        );

        this.sub.sink = this._eventBusService.on(
            "setGridHeaderQuery",
            (data) => (this.query = data)
        );
        this.sub.sink = this._eventBusService.on("setSortByCol", (column) =>
            this.setSortByCol(column)
        );
        this.sub.sink = this._eventBusService.on(
            "setReverseSort",
            (sortOrder) => this.setReverseSort(sortOrder)
        );
    }

    //ngOnChanges(changes: SimpleChanges) {
    //    for (const propName in changes) {
    //        if (propName === "departments") {
    //            const current = changes["departments"]["currentValue"];
    //            if (current) {
    //                this.manipulateDeptAccess();
    //                const deptKeysWithAccess = this.getBUAccessKeyList(
    //                    this.departments
    //                );
    //                this.initUiDeptSections(deptKeysWithAccess);
    //                setTimeout(() => this.emitLatestUiSettings(), 100);
    //            }
    //        }
    //    }
    //}
    ngOnInit() {
        this.subscribeEventHandlers();
        this.viewContainerRef.createEmbeddedView(this.headerTemplate);
        setTimeout(
            () => this.viewContainerRef.element.nativeElement.remove(),
            100
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
